import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/cn';

export function Loader({ className }: { className?: string }): JSX.Element {
  return (
    <Loader2
      className={cn('h-5 w-5 animate-spin text-mb-text-muted', className)}
      aria-label="Loading"
    />
  );
}

export function FullPageLoader(): JSX.Element {
  return (
    <div className="flex h-screen items-center justify-center">
      <Loader className="h-6 w-6" />
    </div>
  );
}
